import {
	Component,
	Input,
	ElementRef,
	HostListener,
	AfterViewInit,
	ViewChild
} from '@angular/core';

@Component({
	selector: 'ea-ui-sticky',
	templateUrl: './sticky.component.html',
	styleUrls: ['./sticky.component.scss']
})
export class StickyComponent implements AfterViewInit {
	@Input() zIndex = 1049;
	@ViewChild('stickySpacer') spacerElement: ElementRef;
	@ViewChild('stickyContent') contentElement: ElementRef;
	isStickyActive: boolean;
	elementPos = 0;

	constructor(private readonly element: ElementRef<HTMLElement>) {}

	ngAfterViewInit(): void {
		this.elementPos = this.element.nativeElement.offsetTop;
		this.spacerElement.nativeElement.style.height = `${this.contentElement.nativeElement.offsetHeight}px`;
	}

	@HostListener('window:scroll', ['$event'])
	toggleSticky(): void {
		this.isStickyActive = window.pageYOffset >= this.elementPos;
	}
}
